import {API} from 'aws-amplify';

// @ts-ignore
export const read = () => API.get('ihrespezialistenBackend', '/version', {});
